import React from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { OnFormSubmitProp, StagesSendFunds } from '@shared/types/frontend/sendFunds';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ScrollArea } from '@/components/ui/scroll-area';
import ReceiverItemView from './receiverItemView';
import useGetUserProfileInfo from '@/hooks/auth/useGetUserProfileInfo';
import { useFollowingQuery } from '@/hooks/following/useFollowing';
const RecentTransfers = ({
  onFormSubmit,
  setStage,
  onlyUsername = false
}: {
  onFormSubmit?: OnFormSubmitProp;
  setStage: (_: StagesSendFunds) => void;
  onlyUsername: boolean;
}) => {
  const [recentUsers] = useLocalStorage('recent-users', []);
  const [recentWallets] = useLocalStorage('recent-wallets', []);
  const {
    userName: username
  } = useGetUserProfileInfo();
  const {
    data: allFollowingData
  } = useFollowingQuery({
    username: username
  });
  const allFollowing = {
    feed: allFollowingData?.feed,
    following: allFollowingData?.following?.filter((x, idx) => {
      //remove duplicates
      return allFollowingData?.following?.findIndex(y => y.username === x.username) === idx;
    })
  };
  const following = allFollowing?.following?.filter(x => x.status === 'public' || x.status === 'private' || x.status !== 'pending');
  return <Tabs defaultValue='username' className='w-full' data-sentry-element="Tabs" data-sentry-component="RecentTransfers" data-sentry-source-file="recentTransfers.tsx">
      <TabsList className='bg-transparent mb-8' data-sentry-element="TabsList" data-sentry-source-file="recentTransfers.tsx">
        <div className='grid gap-2 px-3'>
          <p className='opacity-50 text-[10px]'>Recents:</p>
          <div className='flex gap-2'>
            <TabsTrigger value='username' className='bg-genius-purple h-[26px] text-genius-cream font-light data-[state=active]:font-normal data-[state=active]:text-gray-800 data-[state=active]:bg-genius-pink rounded-full' data-sentry-element="TabsTrigger" data-sentry-source-file="recentTransfers.tsx">
              Genius Users
            </TabsTrigger>
            {!onlyUsername && <TabsTrigger value='external-wallets' className='bg-genius-purple h-[26px] text-genius-cream font-light data-[state=active]:font-normal data-[state=active]:text-gray-800 data-[state=active]:bg-genius-pink rounded-full'>
                External Wallets
              </TabsTrigger>}
            <TabsTrigger value='friends' className='bg-genius-purple h-[26px] text-genius-cream font-light data-[state=active]:font-normal data-[state=active]:text-gray-800 data-[state=active]:bg-genius-pink rounded-full' data-sentry-element="TabsTrigger" data-sentry-source-file="recentTransfers.tsx">
              All Friends
            </TabsTrigger>
          </div>
        </div>
      </TabsList>
      <TabsContent value='username' data-sentry-element="TabsContent" data-sentry-source-file="recentTransfers.tsx">
        <ScrollArea className='h-[250px] mb-16' data-sentry-element="ScrollArea" data-sentry-source-file="recentTransfers.tsx">
          {recentUsers.length > 0 ? <div className='grid gap-4'>
              {[...recentUsers].reverse().map(user => <div key={user.username}>
                  <ReceiverItemView user={user} onFormSubmit={onFormSubmit} setStage={setStage} />
                </div>)}
            </div> : <p className='px-4 text-genius-cream/80 text-sm'>
              Your recently searched users will show up here.
            </p>}
        </ScrollArea>
      </TabsContent>
      <TabsContent value='external-wallets' data-sentry-element="TabsContent" data-sentry-source-file="recentTransfers.tsx">
        <ScrollArea className='h-[250px]' data-sentry-element="ScrollArea" data-sentry-source-file="recentTransfers.tsx">
          {recentWallets.length > 0 ? <div className='grid gap-4'>
              {[...recentWallets].reverse().map(wallet => <div key={wallet.address}>
                  <ReceiverItemView wallet={wallet} onFormSubmit={onFormSubmit} setStage={setStage} />
                </div>)}
            </div> : <p className='px-4 text-genius-cream/80 text-sm'>
              Your recently searched wallets will show up here.
            </p>}
        </ScrollArea>
      </TabsContent>
      <TabsContent value='friends' data-sentry-element="TabsContent" data-sentry-source-file="recentTransfers.tsx">
        <ScrollArea className='h-[250px] mb-16' data-sentry-element="ScrollArea" data-sentry-source-file="recentTransfers.tsx">
          {following && following?.length > 0 ? <div className='grid gap-4'>
              {[...following].reverse().map(user => <div key={user.username}>
                  <ReceiverItemView user={user} onFormSubmit={onFormSubmit} setStage={setStage} />
                </div>)}
            </div> : <p className='px-4 text-genius-cream/80 text-sm'>
              Your recently searched users will show up here.
            </p>}
        </ScrollArea>
      </TabsContent>
    </Tabs>;
};
export default RecentTransfers;